import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';

import {map} from 'rxjs/operators';

import {
    ServerResponse,
    ServerResponseData,
    HttpStatusCodesEnum,
    ReportsService,
    DocumentReportInterface,
    DocumentFilterModel,
    DocumentReportModel
} from '@spa/api';

import {FilterControl, Helper} from 'appShared/classes';
import {ReportTableConfigInterface} from 'appShared/components';

import {DocumentsReportResolverErrorStatesEnum} from '../enums';
import {DocumentsReportResolverDataInterface} from '../interfaces';
import {CacheCollectionService} from 'appShared/services';
import {ComponentStorageKeyProvider} from 'appShared/providers';

export abstract class DocumentsReportResolver implements Resolve<ServerResponse<DocumentsReportResolverDataInterface>> {
    protected componentStorageKeyProvider: ComponentStorageKeyProvider;

    protected constructor(protected reportsService: ReportsService,
                          protected cacheCollectionService: CacheCollectionService,
                          protected storageId: string) {
        this.componentStorageKeyProvider = new ComponentStorageKeyProvider(storageId);

    }

    protected abstract getDefaultFilterModel(): DocumentFilterModel;

    protected abstract getFilterControls(): FilterControl[];

    protected abstract getDataTableConfig(): ReportTableConfigInterface;

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): ServerResponse<DocumentsReportResolverDataInterface> {
        const filterCache = this.cacheCollectionService.getItem(this.componentStorageKeyProvider.getFilterModelKey())?.data;
        const filter = filterCache ?? this.getDefaultFilterModel();

        return this.reportsService.getDocumentsReport(filter).pipe(
            map((response: ServerResponseData<DocumentReportInterface[]>) => {
                if (response.status !== HttpStatusCodesEnum.Ok) {
                    return Helper.errorsHelper().createErrorResponse<DocumentReportInterface[]>(
                        response,
                        DocumentsReportResolverErrorStatesEnum.GetDocumentFailed
                    );
                }

                let modelsCollection = [];

                if (!Helper.errorsHelper().checkForInvalidRespondedArray<DocumentReportInterface>(response)) {
                    modelsCollection = (response.data as DocumentReportInterface[])
                        .map((item: DocumentReportInterface) => {
                            return new DocumentReportModel(item);
                        });
                }

                return Helper.createSuccessResponse<DocumentsReportResolverDataInterface>({
                    modelsCollection,
                    dataTableConfig: this.getDataTableConfig(),
                    filterControls: this.getFilterControls()
                });
            })
        );
    }
}
